// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingContainer[data-v-4158c86a]{position:absolute;top:0;left:0;width:100vw;height:100%;z-index:8000;background-color:rgba(92,87,87,.651)}.loading_message[data-v-4158c86a]{color:#fff;margin:auto;position:absolute;top:50%;left:40%;font-size:20px}", ""]);
// Exports
module.exports = exports;
